// extracted by mini-css-extract-plugin
export default {"modalOverlay":"IC-z","modalContent":"JC-z","header":"KC-z","close":"LC-z"};